module.exports = __webpack_public_path__ + "img/rubin_benefit_17_train.a70bbcb9.svg";